import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from 'lodash-es';
import { useEffect } from 'react';
import { Navigate, Route as ReactRoute, RouterProvider, createBrowserRouter, createRoutesFromElements, } from 'react-router-dom';
import { NotFound } from './404';
const makeRouter = (routers) => {
    if (isEmpty(routers)) {
        return _jsx("span", { children: "not found routers" });
    }
    return [
        ...routers.map(({ path, element: Element, children, redirect, ...rest }, key) => {
            return isEmpty(children) ? (_jsx(ReactRoute, { path: path, element: 
                // <Suspense fallback={<Loading />}>
                _jsx(Element, {}), ...rest }, `${path}-${key}`)) : (_jsxs(ReactRoute, { path: path, element: 
                // <Suspense fallback={<Loading />}>
                _jsx(Element, {}), ...rest, children: [redirect ? (_jsx(ReactRoute, { path: path, element: _jsx(Navigate, { to: redirect, replace: true }) })) : (_jsx(ReactRoute, { path: path, element: _jsx(Navigate, { to: children[0].path, replace: true }) })), !isEmpty(routers) ? makeRouter(children) : null] }, `${path}-${key}`));
        }),
        _jsx(ReactRoute, { path: "*", element: _jsx(NotFound, {}) }, 'not-found'),
    ];
};
export const Route = ({ router, basename = '/' }) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);
    const routers = createBrowserRouter(createRoutesFromElements(makeRouter(router)), {
        basename: basename,
    });
    return _jsx(RouterProvider, { router: routers });
};
